import {
    useLayoutEffect,
    useEffect,
    useState
} from "react";
import {
    ActivityIndicator,
    Vibration,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitTheme,
    PageContainer,
    Text,
    NCoreUIKitLocalize
} from "ncore-ui-kit";
import {
    useIsFocused
} from "@react-navigation/native";
import {
    Armchair
} from "lucide-react-native";
import {
    RESTService
} from "../../../services/restAPI";
import ThreeTServiceInherit from "../../../services/threeT/context";
import {
    storage
} from "../../../storage";

const ThreeTTableInfo = () => {
    const isFocused = useIsFocused();
    const theme = NCoreUIKitTheme.useContext();
    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [
        showTableInfo,
        setShowTableInfo
    ] = useState(false);

    const [
        isFinished,
        setIsFinished
    ] = useState(false);

    const [
        tableNo,
        setTableNo
    ] = useState<number>();



    const getTableInfo = async (isGuest: boolean) => {
        const action = isGuest ? "GetGuestTableInfo" : "GetMemberTableInfo";
        await RESTService.action(action, null)
            .then((res) => {
                setTableNo(res.payload.tableNo as number);
                setShowTableInfo(true);
            })
            .catch(() => {
                // ignore
            });
    };

    const getStatus = async () => {
        const accessToken = storage.getString("accessToken");
        const isGuest = !accessToken;

        if (isGuest) {
            getTableInfo(true);
            return;
        }

        await RESTService.action("GetParticipantActiveState", null)
            .then((res) => {
                if (res.payload.isActive) {
                    getTableInfo(false);
                }
            })
            .catch(() => {
            });
    };

    useLayoutEffect(() => {
        if (isFocused) {
            getStatus();
        }
    }, [isFocused]);

    const approve = (data: unknown) => {
        const d = data as { tableNo: number };
        Vibration.vibrate(500);
        setTableNo(d.tableNo);
        setShowTableInfo(true);
    };

    const changeRound = (data: unknown) => {
        const d = data as { tableNo: number };
        Vibration.vibrate([
            0,
            500,
            200,
            500
        ]);
        setTableNo(d.tableNo);
    };

    const finishedThreeT = () => {
        Vibration.vibrate(1000);
        setIsFinished(true);
    };

    useEffect(() => {
        ThreeTServiceInherit.addEventListenerWithID("participation-approved", "threeT-table", approve);
        ThreeTServiceInherit.addEventListenerWithID("new-round", "threeT-table", changeRound);
        ThreeTServiceInherit.addEventListenerWithID("three-t-finished", "threeT-table", finishedThreeT);

        return () => {
            ThreeTServiceInherit.removeEventListenerWithID("threeT-table");
        };
    }, []);

    const renderWaiting = () => {
        return <View
            style={stylesheet.loadingContainer}
        >
            <ActivityIndicator
                size="large"
            />
            <Text
                variant="bodyMediumSize"
            >
                {localize("statusCheckingOrWaitingApproval")}
            </Text>
        </View>;
    };

    const renderInfo = () => {
        if (isFinished) {
            return <View
                style={[
                    stylesheet.finishedContainer,
                    {
                        padding: theme.spaces.spacingLg
                    }
                ]}
            >
                <Text
                    variant="titleMediumSize"
                    style={[
                        stylesheet.finishedText,
                        {
                            color: theme.colors.content.text.high
                        }
                    ]}
                >
                    {localize("threeTFinishedThanksForJoining")}
                </Text>
            </View>;
        }

        return <View
            style={[
                stylesheet.tableInfoContainer,
                {
                    gap: theme.spaces.spacingLg
                }
            ]}
        >
            <Text
                variant="titleMediumSize"
            >
                {localize("yourTableInfo")}
            </Text>
            <View
                style={[
                    stylesheet.tableIconContainer,
                    {
                        backgroundColor: theme.colors.content.container.subtle,
                        borderRadius: theme.radiuses.full,
                        shadowColor: theme.colors.system.shadow
                    }
                ]}
            >
                <Armchair
                    size={80}
                    color="#4a4a4a"
                />
                {tableNo ? <Text
                    variant="titleLargeSize"
                    style={[
                        stylesheet.tableNoText,
                        {
                            color: theme.colors.content.text.high
                        }
                    ]}
                >
                    {tableNo}
                </Text> : <ActivityIndicator
                    size="small"
                />}
            </View>
        </View>;
    };

    return <PageContainer
        isScrollable={true}
    >
        <View
            style={[
                stylesheet.container,
                {
                    padding: theme.spaces.spacingMd
                }
            ]}
        >
            {!isFinished && <Text
                variant="titleLargeSize"
                style={[
                    stylesheet.welcomeText,
                    {
                        color: theme.colors.content.text.high,
                        marginBottom: theme.spaces.spacingLg
                    }
                ]}
            >
                {localize("welcome")}
            </Text>}
            {showTableInfo ? renderInfo() : renderWaiting()}
        </View>
    </PageContainer>;
};
export default ThreeTTableInfo;
